import styled from "styled-components";
import React, { ReactNode } from "react";

interface InputProps {
  icon?: ReactNode;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  name?: string;
  className?: string;
  disabled?: boolean;
  autoComplete?: string;
}

interface StyledInputProps {
  $hasIcon?: boolean;
}

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  padding: var(--spacing-2) var(--spacing-3);
  padding-left: ${(props) =>
    props.$hasIcon ? "calc(var(--spacing-3) * 2 + 20px)" : "var(--spacing-3)"};
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: var(--color-text-primary);
  font-size: 1rem;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    background-color: rgba(255, 255, 255, 0.15);
  }

  &::placeholder {
    color: var(--color-text-secondary);
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  left: var(--spacing-3);
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
`;

export const Input = ({
  icon,
  type,
  placeholder,
  value,
  onChange,
  required = false,
  name,
  className,
  disabled = false,
  autoComplete,
}: InputProps) => (
  <InputWrapper className={className}>
    {icon && <IconWrapper>{icon}</IconWrapper>}
    <StyledInput
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      name={name}
      disabled={disabled}
      autoComplete={autoComplete}
      $hasIcon={!!icon}
    />
  </InputWrapper>
);
